import { Button, Stack } from '@mui/material'
import React, { useState } from 'react'
import { FormProvider, useForm } from "react-hook-form"
import { useHistory } from 'react-router-dom'
import { useServices } from 'cng-web-lib'
import UserPasswordUrls from 'src/apiUrls/UserPasswordUrls'
import { Field } from "../components/Field"
import { useTranslations } from "./useTranslations"
import { FormActions, FormTitle } from '../components'
import { useSnackbar } from 'notistack'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'

export const ForgotPasswordPage = () => {
  const form = useForm({
    defaultValues: {
      userId: '',
      emailAddress: '',
    }
  })
  const translatedTextsObject = useTranslations()
  const history = useHistory()
  const { securedSendRequest } = useServices()
  const { enqueueSnackbar } = useSnackbar()


  const [loading, setLoading] = useState(false)

  const backToLogin = () => history.push('/login')

  const onSubmit = data => {
    setLoading(true)
    data.userId = data.userId.toLowerCase()
    securedSendRequest.execute(
      'POST',
      UserPasswordUrls.FORGOT_PASSWORD,
      data,
      (response) => {
        if (response.status === 200) {
          if (response.data) {
            const errorMessages = response.data.errorMessages

            if (errorMessages != null && errorMessages.length === 0) {
              enqueueSnackbar(translatedTextsObject.submitSuccessMessage, { variant: 'success' })
              history.push('/login')
            } else {
              errorMessages.forEach((message) =>
                enqueueSnackbar(message, { variant: 'error' })
              )
            }
          }
        }
        setLoading(false)
      },
      () => {
        enqueueSnackbar(translatedTextsObject.submitErrorMessage, { variant: 'error' })
        setLoading(false)
      }
    )
  }

  return <FormProvider {...form}>
    <FormTitle id="forgotPasswordTitle">Forgot password?</FormTitle>

    <Stack gap='1.5rem'>
      <Field label={translatedTextsObject.userId}
        name='userId' required
        disabled={loading}
      />
      <Field label={translatedTextsObject.emailAddress}
        name='emailAddress'
        required disabled={loading}
      />
    </Stack>

    <FormActions>
      <Button variant='outlined'
        fullWidth id="backToLogin"
        onClick={backToLogin}
        disabled={loading}
      >
        Cancel
      </Button>
      <Button type='submit' variant='contained'
        fullWidth id="submitForgotPassword"
        onClick={form.handleSubmit(onSubmit)}
        disabled={loading}
        startIcon={loading
          ? <FontAwesomeIcon icon={faSpinnerThird} spin />
          : null
        }
      >
        Submit
      </Button>
    </FormActions>
  </FormProvider>
}